import {Component, OnInit} from '@angular/core';
import {SocketService} from "../../services/socket.service";

import moment from 'moment-timezone/moment-timezone.js';
moment.tz.load({
    "version": "2023c",
    "zones": [
        "Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6"
    ],
    "links": [
        "Europe/Paris|Europe/Monaco"
    ],
    "countries": [
        "FR|Europe/Paris",
        "MC|Europe/Paris Europe/Monaco"
    ]
})

import {Timer} from 'easytimer.js';
import {BehaviorSubject} from "rxjs";
import {Planning} from "../../interface/planning";
import {ChannelStream} from "../../interface/channel-stream";
import tippy from "tippy.js";
import * as Flickity from "flickity";
import {PlanningCarouselService} from "../../services/planning-carousel.service";

@Component({
    selector: 'app-tab-stream',
    templateUrl: './tab-stream.component.html',
    styleUrls: ['./tab-stream.component.scss']
})
export class TabStreamComponent implements OnInit {

    private timer;

    public streamTimer = new BehaviorSubject<string>("00:00:00:00");
    public holidayEnd = new BehaviorSubject<string>("01/01/2000 à 00:00");
    public previewThumbnail = new BehaviorSubject<string>("");
    public previewTitle = new BehaviorSubject<string>("");
    public previewViewers = new BehaviorSubject<string>("0");
    public flickityElement;

    constructor(public socketService: SocketService, public planningCarouselService: PlanningCarouselService) {

        this.timer = new Timer({precision: 'secondTenths'});
        this.timer.start();
    }

    ngOnInit() {

        this.flickityElement = new Flickity(document.querySelector('.carousel'), {
            wrapAround: true,
            contain: true,
            prevNextButtons: false,
            pageDots: false
        });

        this.planningCarouselService.setCarousel(this.flickityElement);

        this.observeHoliday();
        this.observeTimer();
        this.observeLivePreview();
        this.observePlanning();
    }

    observePlanning() {

        this.socketService.dataPlanning.subscribe((newDataPlanning: Planning) => {

            if (newDataPlanning.week.length === 0) return;

            this.flickityElement.getCellElements().forEach((flickityCell) => {
                this.flickityElement.remove(flickityCell);
            });

            let carouselIndex = 0;
            let carouselIndexScroll = 0;
            let weekDays = ["1", "2", "3", "4", "5", "6", "0"];

            for (let index = 0, len = weekDays.length; index < len; index++) {

                let day = newDataPlanning.week[weekDays[index]];

                if (day.enabled) {

                    let element = document.createElement("div");
                    element.classList.add("carousel-cell");
                    element.classList.add("day");

                    if ((new Date()).getDay().toString() === weekDays[index]) {
                        element.classList.add("active");
                    }

                    if (day.canceled) {
                        element.classList.add("cancel");
                    }

                    if (day.message.replace(/\n/g, "<br/>").length > 0) {
                        element.classList.add("message");
                        // @ts-ignore
                      element.dataset.tippyPlanning = "";
                        // @ts-ignore
                      element.dataset.tippyContent = day.message.replace(/\n/g, "<br/>");
                    }

                    let spanLabel = document.createElement("span");
                    spanLabel.innerHTML = day.label.substring(0, 3);
                    element.appendChild(spanLabel);

                    let spanStart = document.createElement("span");
                    spanStart.innerHTML = (day.canceled) ? "Annulé" : day.start;
                    element.appendChild(spanStart);

                    this.flickityElement.append(element);

                    if ((new Date()).getDay().toString() === weekDays[index]) {
                        carouselIndexScroll = carouselIndex;
                    }

                    carouselIndex++;
                }
            }

            if (carouselIndexScroll === 0) {
                carouselIndexScroll = carouselIndex;
            }

            this.flickityElement.reloadCells();
            this.flickityElement.select(carouselIndexScroll, true, true);

            this.planningCarouselService.resize();

            tippy('[data-tippy-planning]', {arrow: true, theme: "locklear", allowHTML: true});
        });
    }

    carouselPrevious() {
        this.flickityElement.previous(true, false);
    }

    carouselNext() {
        this.flickityElement.next(true, false);
    }

    observeTimer() {

        if (this.socketService.dataPlanning.value.extra && this.socketService.dataPlanning.value.extra.next) {
            let nextDate = moment.utc(this.socketService.dataPlanning.value.extra.next).tz("Europe/Paris");
            this.updateCountdown(nextDate.diff(moment.utc(moment()).tz("Europe/Paris")));
        }

        this.timer.addEventListener('secondTenthsUpdated', (e) => {

            if (this.socketService.dataPlanning.value.extra && this.socketService.dataPlanning.value.extra.next) {
                let nextDate = moment.utc(this.socketService.dataPlanning.value.extra.next).tz("Europe/Paris");
                this.updateCountdown(nextDate.diff(moment.utc(moment()).tz("Europe/Paris")));
            }
        });
    }

    observeHoliday() {

        this.socketService.dataPlanning.subscribe((newDataPlanning: Planning) => {

            if (newDataPlanning.extra.next === null) return;

            this.holidayEnd.next(moment.utc(newDataPlanning.extra.next).tz("Europe/Paris").format("DD/MM/YYYY à H:m"));
        });
    }

    observeLivePreview() {

        this.socketService.dataChannelStream.subscribe((newDataStream: ChannelStream) => {

            if (newDataStream.stream === null) return;

            let thumbnailUrl = "";
            if (newDataStream.stream.hasOwnProperty("thumbnail64")) {
                thumbnailUrl = newDataStream.stream.thumbnail64;
            } else {
                thumbnailUrl = newDataStream.stream.thumbnail.replace("{width}", "540").replace("{height}", "306") + "?" + (new Date()).getMinutes();
            }

            this.previewThumbnail.next(thumbnailUrl);
            this.previewTitle.next(newDataStream.stream.title);
            this.previewViewers.next(newDataStream.stream.viewers.toLocaleString());
        });
    }

    updateCountdown(secondLeft) {

        if (secondLeft <= 0) {
            this.streamTimer.next("00:00:00:00");
            return false;
        }

        let days = Math.floor(secondLeft / (1000 * 60 * 60 * 24));
        let hours = Math.floor((secondLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((secondLeft % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((secondLeft % (1000 * 60)) / 1000);

        this.streamTimer.next(days.toString().padStart(2, '0') + ":" + hours.toString().padStart(2, '0') + ":" + minutes.toString().padStart(2, '0') + ":" + seconds.toString().padStart(2, '0'));
    }

    openLive() {
      window.open("https://www.twitch.tv/locklear");
    }
}
